// import AddDefaultCofigValue from './Containers/add_default_config_value';
import {AppSettings} from '../constants';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const AddDefaultCofigValue = Loadable({
  loader: () => import('./Containers/add_default_config_value'),
  loading: Loading
});

export default [
  {
    path: '/default-config',
    component: AddDefaultCofigValue,
    private: true,
    portal: ['Builder','Homeowner'],
    menu: {
      name: 'Default Config',
      group: 'Admin',
      icons: 'icon-cost-codes-ic',
      order: 1,
      subGroup: 'Other',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/DefaultConfig/routers.js